import React, { useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import useAuth from "../context";

const TempDashBoard = () => {
    const [open, setOpen] = useState(true);
    const auth = useAuth();

    const handleDrawerToggle = () => {
        setOpen(!open);
    };

    return (
        <Box sx={{ display: "flex", height: "100vh", width: "100%" }}>
            <CssBaseline />
            {/* Sidebar */}
            <Sidebar open={open} handleDrawerToggle={handleDrawerToggle} />

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    padding: 3,
                    transition: "margin-left 0.3s ease",
                    width: open ? `calc(100% - 240px)` : `calc(100% - 60px)`,
                    backgroundColor: "#fff",
                    height: "100vh",
                    overflow: "auto",
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Outlet />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default TempDashBoard;
